import React from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';
import { getValidationReason } from '@src/utils/validationReasonMap';
// import './ValidationDialog.css';


export interface ValidationFile {
  fileName: string;
  originalFileName?: string;
  statusCode: number;
  reason?: string;
}

interface ValidationDialogProps {
  open: boolean;
  files: ValidationFile[];
  validationStatusCode: number | null;
  onContinue: () => void;
  onReupload: () => void;
}

const ValidationDialog: React.FC<ValidationDialogProps> = ({
  open,
  files,
  validationStatusCode,
  onContinue,
  onReupload,
}) => {
  if (!open) return null;

  const invalidFiles = files.filter((f) => f.statusCode !== 200);
  const showContinue = validationStatusCode === 401;

  return (
    <div className="validation-dialog-overlay">
      <div
        className="validation-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="validation-dialog-title"
      >
        <div className="validation-dialog-header">
          <span className="validation-dialog-icon">&#9888;</span>
          <h3 id="validation-dialog-title">File Validation Issues</h3>
        </div>
        <p className="validation-dialog-message">
          {showContinue
            ? 'Some of your uploaded files could not be validated. Please review the below and choose to continue with valid files or reupload:'
            : 'All uploaded files are invalid. Please review the below and reupload your files:'}
        </p>
        <div className="validation-dialog-file-list">
          <table className="validation-table">
            <thead>
              <tr>
                <th>File Name</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {invalidFiles.map((file, index) => (
                <tr key={`${file.originalFileName || file.fileName}-${index}`}>
                  <td className="validation-file-name">{file.originalFileName || file.fileName}</td>
                  <td className="validation-file-reason">
                    {getValidationReason(file.statusCode)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="validation-dialog-actions">
          {showContinue && <Button onClick={onContinue}>Continue</Button>}
          <Button onClick={onReupload} variant="outline">
            Reupload
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ValidationDialog;
